module.exports = __webpack_public_path__ + "files/69f9d15a56fff48a28ca807b9df4f969.png";